import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import StyledComponent from '~/components/Styled/Styled';
import get from 'lodash/get';

import css from './Shootout.scss';

const cssContext = classnames.bind(css);

const RenderShootColumn = ({ data, teamName }) => {
  const isHockey = Object.prototype.hasOwnProperty.call(data[0], 'skater');
  const playerAccessor = isHockey ? 'skater.full_name' : 'player.full_name';

  return (
    <div className={css.team}>
      <div className={css.teamName}>{teamName}</div>

      {data.map(shooting => {
        const playerFullname = get(shooting, playerAccessor, '');
        const name = cssContext(css.name, {
          successfulGoalScorer: shooting.successful,
        });
        const mark = cssContext(css.mark, {
          successfulMark: shooting.successful,
        });

        return (
          <div key={`shooting-${shooting.id}`} className={css.shooting}>
            <div className={name}>{playerFullname}</div>
            <div className={mark}>
              {(isHockey && shooting.successful) || (!isHockey && shooting.shootout_outcome) ? (
                <span>
                  <img
                    className={css.hockeyPuck}
                    src="/static/vectors/sportIcons/hockey.svg"
                    alt="Goal"
                  />
                </span>
              ) : (
                <span className={css.x}>✕</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const Shootout = props => {
  const { awayTeam, homeTeam, shootings } = props;

  if (!shootings.length) {
    return null;
  }

  const teams = {};

  shootings.forEach(shooting => {
    const teamAbv = get(shooting, 'team.abbreviation');
    if (!teams[teamAbv]) {
      teams[teamAbv] = [];
    }
    teams[teamAbv].push(shooting);
  });

  const awayShootout = shootings.filter(ev => ev.alignment === 'away');
  const homeShootout = shootings.filter(ev => ev.alignment === 'home');

  return (
    <div className={css.shootout}>
      <RenderShootColumn data={awayShootout} teamName={awayTeam} />
      <RenderShootColumn data={homeShootout} teamName={homeTeam} />
    </div>
  );
};

RenderShootColumn.propTypes = {
  data: PropTypes.array.isRequired,
  teamName: PropTypes.string.isRequired,
};

RenderShootColumn.defaultProps = {
  data: [],
  teamName: '',
};

Shootout.propTypes = {
  shootings: PropTypes.array.isRequired,
  awayTeam: PropTypes.string.isRequired,
  homeTeam: PropTypes.string.isRequired,
};

RenderShootColumn.defaultProps = {
  shootings: [],
  awayTeam: '',
  homeTeam: '',
};

export default StyledComponent(Shootout, [css]);
